export default __webpack_public_path__ + "static/media/cn.2e5f836f.svg";